import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Box } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var StartLayoutContainer = function StartLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Box, _extends({
    className: "start-container"
  }, props), children);
};
StartLayoutContainer.propTypes = {
  children: PropTypes.node
};
StartLayoutContainer.defaultProps = {
  children: null
};
export { StartLayoutContainer as default };